import type { HTMLAttributes } from 'react';
import { cn } from '@shared/lib/cn';

/** Bloc de chargement (skeleton) avec pulsation douce. */
export function Skeleton({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      aria-hidden="true"
      className={cn('animate-pulse rounded-md bg-slate-200', className)}
      {...props}
    />
  );
}
